var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagingLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5l-.67.665L3.48 11 2 9.67 6.184 5.5 2 1.33 3.48 0l4.85 4.835z",
    fill: "#000"
  })));
}

export default SvgPagingLeftArrow;